<template>
  <footer class="bg-dark text-white py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 text-center">
          <ul class="list-inline mb-4">
            <li class="list-inline-item me-3 mb-2">
              <router-link to="/disclaimer" class="text-white-50 text-decoration-none hover-text-white">
                <span class="d-inline-block border-bottom border-1 pb-1">Data Privacy Disclaimer</span>
              </router-link>
            </li>
            <li class="list-inline-item me-3 mb-2">
              <router-link to="/terms" class="text-white-50 text-decoration-none hover-text-white">
                <span class="d-inline-block border-bottom border-1 pb-1">Terms of Service</span>
              </router-link>
            </li>
            <li class="list-inline-item me-3 mb-2">
              <router-link to="/privacy" class="text-white-50 text-decoration-none hover-text-white">
                <span class="d-inline-block border-bottom border-1 pb-1">Privacy Policy</span>
              </router-link>
            </li>
            <li class="list-inline-item mb-2">
              <router-link to="/sitemap" class="text-white-50 text-decoration-none hover-text-white">
                <span class="d-inline-block border-bottom border-1 pb-1">Sitemap</span>
              </router-link>
            </li>
          </ul>
          <p class="mb-2">&copy; 2025 EnglishMate. All rights reserved.</p>
          <p class="small text-white-50 mb-0 pb-0 fw-light border-top border-secondary border-opacity-25 pt-3 mt-3 mx-auto" style="max-width: 500px;">
            EnglishMate does not store any user data or voice recordings.
          </p>
          <div class="mt-4">
            <router-link to="/contact" class="btn btn-outline-secondary btn-sm rounded-pill px-3">
              Contact Us
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>

<style scoped>
footer {
  background-color: #1a1a1a;
}

h5 {
  font-weight: 600;
  font-size: 1.1rem;
}

.text-white-50 {
  transition: color 0.2s;
}

.text-white-50:hover {
  color: #ffffff !important;
  text-decoration: none;
}
</style>
